module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/common/header/header.component.css
// module id = ./src/app/common/header/header.component.css
// module chunks = main